import { render, staticRenderFns } from "./app.resource.picker.vue?vue&type=template&id=b34af2b8&scoped=true&"
import script from "./app.resource.picker.vue?vue&type=script&lang=js&"
export * from "./app.resource.picker.vue?vue&type=script&lang=js&"
import style0 from "./app.resource.picker.vue?vue&type=style&index=0&id=b34af2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34af2b8",
  null
  
)

export default component.exports